import {
  isNumeric,
  isPrimaryKey,
  isTemporal,
  type Field,
} from "./schema-field";

/**
 * Name-based guesses for chart axes when analyse left every Sheets column as
 * STRING. Forms still use the strict isNumeric / isTemporal checks so a mistyped
 * native picker cannot blank a value on save; charts only need an aggregate
 * request, and the Sheets aggregate path coerces digit strings and parseable
 * dates.
 */

/**
 * Measure-like names. Negative lookahead skips compounds that are really
 * categories (`price_tier`, `score_type`) so those stay usable as groupBy.
 */
const MEASURE_HINTS =
  /(amount|total|sum|budget|cost|price|value|revenue|spend|score|qty|quantity|count|hours|duration)(?![\w-]*(?:tier|level|grade|type|kind|category|class|status)\b)/i;

const TEMPORAL_HINTS =
  /^(date|time|datetime|timestamp|day|month|year|week|due|start|end|finish|completed|shipped|paid|created|updated|deleted|modified)(_|$)|(_|^)(at|on|date|time|day)$/i;

const normalize = (name: string): string =>
  name.trim().toLowerCase().replace(/[\s-]+/g, "_");

/** True when the column should be SUMmed for a chart, typed or by name. */
export const looksNumericForChart = (field?: Field): boolean => {
  if (!field || isPrimaryKey(field)) return false;
  if (isNumeric(field)) return true;
  return MEASURE_HINTS.test(field.name) || MEASURE_HINTS.test(normalize(field.name));
};

/** True when the column should be month-bucketed for a chart, typed or by name. */
export const looksTemporalForChart = (field?: Field): boolean => {
  if (!field || isPrimaryKey(field)) return false;
  if (isTemporal(field)) return true;
  const key = normalize(field.name);
  return TEMPORAL_HINTS.test(key) || key === "date" || key.endsWith("_date");
};
